import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Card as MuiCard,
  Grid as MuiGrid,
  MenuItem as MuiMenuItem,
  Select as MuiSelect,
} from '@mui/material';
import { withStyles } from '@mui/styles';

import { useFormContext } from 'react-hook-form';

import { withFormController } from '../../../../components/hocs/forms';
import { TextFieldBase } from '../../../../components/inputs/TextFieldBase';
import { InputLabelBase as InputLabel } from '../../../../components/inputs/InputLabelBase';

import { MultiSelect } from '../../../../components/Selects';
import { getUsers } from '../../../../api/UserService';
import { useCardStyles } from './ClaimModalStyles';
import { REDACTED_FIELD } from '../../../../config/logrocket';

const TextField = withFormController(TextFieldBase);

export const CreateClaimReporter = withStyles(({ palette }) => ({
  heading: {
    marginTop: 0,
    marginBottom: 25,
    color: palette.common.cowbellBlue,
    textAlign: 'center',
  },
  // @ts-expect-error TS(2339): Property 'classes' does not exist on type 'Consist... Remove this comment to see the full error message
}))(({ classes, editing }) => {
  const cardStyles = useCardStyles();

  // @ts-expect-error TS(2339): Property 'onSelect' does not exist on type 'UseFor... Remove this comment to see the full error message
  const { control, getValues, register, onSelect, onMultiSelect, errors } =
    useFormContext();

  const [names, setnames] = useState([]);
  const formValues = getValues();

  useEffect(
    () => {
      if (!editing) {
        getUsers({ size: 100 }).then((resp: any) => {
          const options = resp.data.content.map(
            ({ account, firstName, lastName, email, id, role }: any) => {
              const fullName = `${firstName} ${lastName}`;
              return {
                email,
                role: role.name,
                organizationName: account.name,
                label: fullName,
                value: id,
              };
            }
          );

          setnames(options);
        });
      }
    },
    // eslint-disable-next-line
    []
  );

  return (
    <MuiCard classes={cardStyles}>
      <h2 className={classes.heading}>Claim Reported By</h2>
      <MuiGrid container spacing={1}>
        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="name" required>
            Name:
          </InputLabel>
        </MuiGrid>
        <MuiGrid className={REDACTED_FIELD} item md={6}>
          {editing ? (
            _.get(formValues, 'name.label', '-')
          ) : (
            <MultiSelect
              name="name"
              isMulti={false}
              options={names}
              onChange={onMultiSelect}
              error={_.get(errors, 'name.value.message')}
            />
          )}
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="role" required>
            Role:
          </InputLabel>
        </MuiGrid>
        <MuiGrid item md={6}>
          {_.get(formValues, 'role', '-')}
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="email" required>
            Email:
          </InputLabel>
        </MuiGrid>
        <MuiGrid className={REDACTED_FIELD} item md={6}>
          {_.get(formValues, 'email', '-')}
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="workPhone">
            Work Phone:
          </InputLabel>
        </MuiGrid>
        <MuiGrid className={REDACTED_FIELD} item md={6}>
          <TextField
            name="workPhone"
            // @ts-expect-error TS(2322): Type '{ control: Control<FieldValues, any>; }' is ... Remove this comment to see the full error message
            controllerProps={{ control }}
            placeholder="(___) ___ - ____"
          />
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="cellPhone">
            Cell Phone:
          </InputLabel>
        </MuiGrid>
        <MuiGrid className={REDACTED_FIELD} item md={6}>
          <TextField
            name="cellPhone"
            // @ts-expect-error TS(2322): Type '{ control: Control<FieldValues, any>; }' is ... Remove this comment to see the full error message
            controllerProps={{ control }}
            placeholder="(___) ___ - ____"
          />
        </MuiGrid>

        <MuiGrid item md={6}>
          <InputLabel inline htmlFor="isRightContact" required>
            Are you the right contact for this claim?
          </InputLabel>
        </MuiGrid>
        <MuiGrid item md={6}>
          <MuiSelect
            variant="standard"
            // @ts-expect-error TS(2783): 'name' is specified more than once, so this usage ... Remove this comment to see the full error message
            name="isRightContact"
            {...register('isRightContact')}
            onChange={onSelect}
            defaultValue={getValues().isRightContact}
          >
            {claimContactOptions.map(({ label, value }) => (
              <MuiMenuItem key={label} value={value}>
                {label}
              </MuiMenuItem>
            ))}
          </MuiSelect>
        </MuiGrid>

        {formValues.isRightContact === 'no' && (
          <>
            <MuiGrid item md={6}>
              <InputLabel inline htmlFor="contactName" required>
                Contact Name for this Claim:
              </InputLabel>
            </MuiGrid>
            <MuiGrid className={REDACTED_FIELD} item md={6}>
              <TextField
                name="contactName"
                required
                // @ts-expect-error TS(2322): Type '{ control: Control<FieldValues, any>; }' is ... Remove this comment to see the full error message
                controllerProps={{ control }}
              />
            </MuiGrid>

            <MuiGrid item md={6}>
              <InputLabel inline htmlFor="contactEmail" required>
                Contact Email for this Claim:
              </InputLabel>
            </MuiGrid>
            <MuiGrid className={REDACTED_FIELD} item md={6}>
              <TextField
                name="contactEmail"
                required
                // @ts-expect-error TS(2322): Type '{ control: Control<FieldValues, any>; }' is ... Remove this comment to see the full error message
                controllerProps={{ control }}
              />
            </MuiGrid>

            <MuiGrid item md={6}>
              <InputLabel inline htmlFor="contactPhone" required>
                Contact Phone for this Claim:
              </InputLabel>
            </MuiGrid>
            <MuiGrid className={REDACTED_FIELD} item md={6}>
              <TextField
                name="contactPhone"
                required
                // @ts-expect-error TS(2322): Type '{ control: Control<FieldValues, any>; }' is ... Remove this comment to see the full error message
                controllerProps={{ control }}
              />
            </MuiGrid>
          </>
        )}
      </MuiGrid>
    </MuiCard>
  );
});

const claimContactOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];
